import { LegacyEpisodePlayerBaseInfoContent } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

export function getEpisodeOtt(episode: LegacyEpisodePlayerBaseInfoContent | undefined | null) {
    if (episode?.episodeOtt?.__typename === 'OttEpisode') {
        return episode.episodeOtt;
    }
}
